import React, { useState, useRef } from "react";
import  {Serviceoffered }  from '../constant/data'
import { ToastContainer, toast } from 'react-toastify';
import emailjs from '@emailjs/browser';
import 'react-toastify/dist/ReactToastify.css';
import { Helmet } from 'react-helmet-async'

function Contact() {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    service: "",
    message: "",
  });
  const [isLoading, setIsLoading] = useState(false);
  const form = useRef(null);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const sendEmail = async (e) => {
    e.preventDefault();
    setIsLoading(true);

    try {
      // Create a FormData object and populate it with form data
      const formDataObject = new FormData(form.current);

      // Map the FormData to the state object
      const data = {};
      formDataObject.forEach((value, key) => {
        data[key] = value;
      });
      setFormData(data);
// console.log(data);
      // Send the email using EmailJS
      const result = await emailjs.sendForm(
        "service_qsvlxdd",
        "template_3tp0qzq",
        form.current,
        "GgcIHmOChlLGj8Btr"
      );

      toast.success("Thank you for your message! We will get back to you soon.", {
       
      });

      console.log("Email sent:", result.text);

      setFormData({
        name: "",
        email: "",
        service: "",
        message: "",
      });

    } catch (error) {
      toast.error("An error occurred while sending your request. Please try again.");
      console.error("Email sending error:", error);
    } finally {
      setIsLoading(false);
    }
  };
 

  return (
    <>
       <Helmet>
                          <title>Contact Us</title>
                          <meta name="description" content="Let’s make something new, different and more meaningful or make something more visual or conceptual."/>
                          <link rel="canonical" href="/Contact"/>
                        </Helmet>
 
    <div>
      <ToastContainer/>
        <div className="container-fluid bg-primary py-5 mb-5 hero-header">
    <div className="container py-5">
      <div className="row justify-content-center py-5">
        <div className="col-lg-10 pt-lg-5 mt-lg-5 text-center">
          <h1 className="display-3 text-white animated slideInDown">
            Contact Us
          </h1>
          <nav aria-label="breadcrumb">
            <ol className="breadcrumb justify-content-center">
              <li className="breadcrumb-item">
                <a href="/">Home</a>
              </li>
              <li
                className="breadcrumb-item text-white active"
                aria-current="page"
              >
                Contact
              </li>
            </ol>
          </nav>
        </div>
      </div>
    </div>
  </div>
      {/* Contact Start */}
      <div className="container-xxl py-5">
      <div className="container">
        <div className="text-center wow fadeInUp" data-wow-delay="0.1s">
          <h6 className="section-title bg-white text-center text-primary px-3">
            Contact Us
          </h6>
          <h1 className="mb-5">Contact For Any Query</h1>
        </div>
        <div className="row g-4">
          <div className="col-lg-4 col-md-6 wow fadeInUp" data-wow-delay="0.1s">
            <h5>Get In Touch</h5>
            <p className="mb-4">
            Let’s make something new, different and more meaningful or make something more visual or conceptual.
            </p>
            <div className="d-flex align-items-center mb-4">
              <div
                className="d-flex align-items-center justify-content-center flex-shrink-0 bg-primary"
                style={{ width: 50, height: 50 }}
              >
                <i className="fa fa-map-marker-alt text-white" />
              </div>
              <div className="ms-3">
                <h5 className="text-primary">Office</h5>
                <p className="mb-0">40 Union Ave, Irvington, NJ 07111, USA</p>
              </div>
            </div>
            <div className="d-flex align-items-center mb-4">
              <div
                className="d-flex align-items-center justify-content-center flex-shrink-0 bg-primary"
                style={{ width: 50, height: 50 }}
              >
                <i className="fa fa-phone-alt text-white" />
              </div>
              <div className="ms-3">
                <h5 className="text-primary">Mobile</h5>
                <p className="mb-0">+1 (724) 473-3093</p>
              </div>
            </div>
            <div className="d-flex align-items-center">
              <div
                className="d-flex align-items-center justify-content-center flex-shrink-0 bg-primary"
                style={{ width: 50, height: 50 }}
              >
                <i className="fa fa-envelope-open text-white" />
              </div>
              <div className="ms-3">
                <h5 className="text-primary">Email</h5>
                <p className="mb-0"> info1@nagspro.com</p>
              </div>
            </div>
          </div>
          <div className="col-lg-4 col-md-6 wow fadeInUp" data-wow-delay="0.3s">
            <iframe
              className="position-relative rounded w-100 h-100"
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3048.9268795611873!2d-74.22761378461418!3d40.72798957933092!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x89c2541e1b39ef37%3A0x9f23bc9c5fd15b31!2s40%20Union%20Ave%2C%20Irvington%2C%20NJ%2007111%2C%20USA!5e0!3m2!1sen!2sus!4v1696961900000!5m2!1sen!2sus"
              frameBorder={0}
              style={{ minHeight: 300, border: 0 }}
              allowFullScreen=""
              aria-hidden="false"
              tabIndex={0}
            />
          </div>
          <div
            className="col-lg-4 col-md-12 wow fadeInUp"
            data-wow-delay="0.5s"
          >
            <form ref={form} onSubmit={sendEmail}>
              <div className="row g-3">
                <div className="col-md-6">
                  <div className="form-floating">
                    <input
                      className="form-control"
                      type="text"
                      id="name"
                      name="name"
                       placeholder="Your Name"
                       value={formData.name}
                       onChange={handleChange}
                       required
                    />
                    <label htmlFor="name">Your Name</label>
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="form-floating">
                    <input
                      className="form-control"
                      type="email"
                        id="email"
                        name="email"
                        value={formData.email}
                        onChange={handleChange}
                        required
                    />
                    
                    <label htmlFor="email">Your Email</label>
                  </div>
                </div>
                <div className="col-12">
                  <div className="form-floating">
                    <select
                      className="form-control"
                   
                      id="service"
                      name="service"
                      value={formData.service}
                      onChange={handleChange}
                      required
                    >
                     <option value="" disabled>
              -- Select a Service --
            </option>
                {Serviceoffered.map((option) => (
                  <option key={option.value} value={option.value}>
                    {option.label}
                  </option>
                     ))}
                     </select>
                    <label htmlFor="subject">Purpose</label>
                  </div>
                </div>
                <div className="col-12">
                  <div className="form-floating">
                    <textarea
                      className="form-control"
                      placeholder="Leave a message here"
                      id="message"
                      name="message"
                      value={formData.message}
                      onChange={handleChange}
                      style={{ height: 100 }}
                      defaultValue={""}
                    />
                    
                    <label htmlFor="message">Message</label>
                  </div>
                </div>
                <div className="col-12">
                  <button className="btn btn-primary w-100 py-3" type="submit"   disabled={isLoading}>
                    {isLoading ? "Loading..." : " Send Message"}
                  </button>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
    {/* Contact End */}
    </div>
    </>
  )
}

export default Contact
